export default __webpack_public_path__ + "1f76cce4735e77cb27061d19ca0ea753.svg";